import React from 'react';
import { Route, Redirect } from 'react-router-dom';

let rota_redireciona = '/auth/login';

export const isAuthenticated = props => {
  const auth = localStorage.getItem('profissional');
  if (auth == null) return false;
  const profissional = JSON.parse(auth);

  if (
    !profissional.visualizaMinhasRequisicoes &&
    props.location.pathname.includes('minhasrequisicoes')
  ) {
    if (!profissional.visualizaBimVirtual && props.location.pathname.includes('bim')) return false;
    rota_redireciona = '/admin/bim';
    return false;
  }

  if (!profissional.visualizaBimVirtual && props.location.pathname.includes('bim')) return false;

  return true;
};

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated(props) ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: rota_redireciona, state: { from: props.location } }} />
      )
    }
  />
);
